import * as React from 'react';
import {Checkbox} from '@sail/ui';

export const Controlled = () => {
  const [checked, setChecked] = React.useState(false);
  return (
    <Checkbox
      onChange={() => {
        setChecked(!checked);
      }}
      checked={checked}
      label="This Checkbox is controlled."
    />
  );
};
